import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-plus',
  templateUrl: './icon-plus.component.html',
  styleUrls: ['./icon-plus.component.scss']
})
export class IconPlusComponent implements OnInit {
  @Input() color: string = '#262628';
  @Input() size: number = 18;
  
  constructor() { }

  ngOnInit() {
  }

}
